import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Link", -1)
const _hoisted_2 = {
  key: 0,
  class: "text-right"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 0,
  class: "text-right"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_7 = { class: "text-right" }

import { AssetManagementPlanLink } from "@/classes/asset-management-plan";
import BaseDialog from "@/components/base/dialogs/BaseDialog.vue";
import { useConfirmStore } from "@/store/confirm";
import { useNotifierStore } from "@/store/notifier";
import { ref } from "vue";

type LinkItem = InstanceType<typeof AssetManagementPlanLink>;

type DialogMode = "Add" | "Edit";


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkTable',
  props: {
    label: {},
    links: {},
    maxHeight: {},
    readonly: { type: Boolean }
  },
  emits: ["add", "update", "delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const notifier = useNotifierStore();
const confirm = useConfirmStore();

const dialog = ref(false);
const dialogMode = ref<DialogMode>("Add");
const link = ref("");
const editItem = ref<LinkItem>();

const openDialog = (mode: DialogMode, item?: LinkItem) => {
  dialog.value = true;
  dialogMode.value = mode;
  link.value = item?.link ?? "";
  editItem.value = item;
};

const saveLink = () => {
  if (!URL.canParse(link.value)) {
    notifier.error("Invalid link");
  } else {
    if (dialogMode.value === "Add") {
      emit("add", link.value);
    } else {
      emit("update", { id: editItem.value?.id ?? "", link: link.value });
    }
    dialog.value = false;
  }
};

const deleteLink = (item: LinkItem) => {
  confirm.open({
    title: "Delete Link?",
    confirmText: "Delete",
    color: "red",
    onConfirm: () => {
      emit("delete", item.id);
    },
  });
};

return (_ctx: any,_cache: any) => {
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    variant: "outlined",
    rounded: "lg"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, { density: "compact" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.label), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_table, {
        "fixed-header": "",
        density: "compact",
        style: _normalizeStyle({ 'max-height': _ctx.maxHeight ? String(_ctx.maxHeight) + 'px' : '' })
      }, {
        default: _withCtx(() => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _hoisted_1,
              (!_ctx.readonly)
                ? (_openBlock(), _createElementBlock("th", _hoisted_2, "Action"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: link.id
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    href: link.link,
                    target: "_blank"
                  }, _toDisplayString(link.link), 9, _hoisted_3)
                ]),
                (!_ctx.readonly)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_4, [
                      _createVNode(_component_v_btn, {
                        icon: "mdi-pencil",
                        variant: "plain",
                        density: "compact",
                        onClick: ($event: any) => (openDialog('Edit', link))
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_v_btn, {
                        icon: "mdi-delete",
                        variant: "plain",
                        color: "red",
                        density: "compact",
                        onClick: ($event: any) => (deleteLink(link))
                      }, null, 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (!_ctx.readonly)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("td", _hoisted_7, [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "text",
                      class: "mt-2 mb-2",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (openDialog('Add')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-plus")
                          ]),
                          _: 1
                        }),
                        _createTextVNode("Add ")
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["style"]),
      _createVNode(BaseDialog, {
        modelValue: dialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialog).value = $event)),
        title: `${dialogMode.value} Link`
      }, {
        actions: _withCtx(() => [
          _createVNode(_component_v_btn, { onClick: saveLink }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(dialogMode.value), 1)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            modelValue: link.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((link).value = $event)),
            label: "Link",
            density: "compact",
            variant: "outlined",
            "hide-details": ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _: 1
  }))
}
}

})